const serverList=[
    {
        title:"调试",
        server:"http://localhost:5000",
        merchantApiServer:"",
        merchantServer:""
    },
    {
        title:"代理",
        server:"",
        merchantApiServer:"http://www.vvdt.cc",
        merchantServer:"http://www.vvdt.cc",
    },
    {
        title:"代理",
        server:"",
        merchantApiServer:"http://www.vvdt.cc:8000",
        merchantServer:"http://www.vvdt.cc:8000",
    },
    {
        title:"代理",
        server:"",
        merchantApiServer:"http://www.damowang.cc",
        merchantServer:"http://www.damowang.cc",
    },
]

 const systemType= 2;  

 export const config = serverList[systemType];